import { Component, OnInit } from '@angular/core';
import { externalUrls} from './../../../config/config/config.constants';
import { LoginService} from './../../../services/login/login.service';
import { localConsole } from './../../../utils/local-console';
declare function require(path: string);
declare const window: any;

@Component({
  selector: 'app-cvs-mdp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public isMobileChannel: boolean;
  public year = new Date().getFullYear();
  public vipps_logo = require( './../../../../../assets/images/vipps.jpg');
  public app_store_icon = require('./../../../../../assets/images/footer/apple-app-store.png');
  public feedback_gif = require('./../../../../../assets/images/footer/sm_666_oo.gif');

  constructor(private _auth: LoginService) { }

  ngOnInit() {
    this.isMobileChannel = window.native;
  }
  initiateTransfer(e) {
    e.preventDefault();
    if (this._auth.userData.authenticated) {
      window.location.href = externalUrls.iceV1Url  + '/#/pharmacy/rxTransfer';
    } else {
      window.location.href = externalUrls.rootUrl + '/pharmacy/rxtransfer/transfer';
    }
  }
  /**
   * Add error handler to
   * opinionLab feedback method
  */
  public triggerOpinionLab(): void {
    try {
      window.OOo.oo_implementationShow();
    } catch (e) {
      localConsole.log('opinionLab error --> ' , e);
    }
  }
}
